import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Form, Input, Dropdown} from 'semantic-ui-react';
import {WARRANTIES_OPERATION_TYPES} from '../../constants';
import {Actions} from '../../../common/actions';

class PrincipalPart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'usePrincipalPart': false,
    };
  }

  componentDidUpdate() {
    const {usePrincipalPart} = this.state;
    const {handleChange, principalPart, part} = this.props;

    if (usePrincipalPart && principalPart === part.code) {
      handleChange('principalPartDescription', part.name);
      this.setState({
        'usePrincipalPart': false,
      });
    }
  }

  handleKeyDown = (e) => {
    const {principalPart} = this.props;
    if (e.key === 'Enter') {
      if (principalPart.length > 1) {
        this.props.getWarrantyAdminPart(principalPart);
        this.setState({
          'usePrincipalPart': true,
        });
      }
    }
  }

  renderOperationTypeDropdown() {
    const {handleChange, disabledBtns, operationType} = this.props;
    return (
      <div className='field'>
        <label>Tipo de Operación</label>
        <Dropdown
          selection
          options={WARRANTIES_OPERATION_TYPES}
          disable={disabledBtns}
          value={operationType}
          search
          name='list-sequences-container'
          onChange={(e, {value}) => handleChange('operationType', value)}
          placeholder='Tipo de Operación'
        />
      </div>
    );
  }

  render() {
    const {handleChange, handleSearchPart, principalPart, principalPartDescription, disabledBtns} = this.props;
    return (
      <Form.Group widths='three'>
        <Form.Field
          disabled={disabledBtns}
          value={principalPart}
          control={Input}
          label='OFP Parte Principal'
          placeholder='OFP Parte Principal'
          onKeyDown={this.handleKeyDown}
          onChange={(e, {value}) => handleSearchPart(value)}
        />

        <Form.Field
          value={principalPartDescription}
          control={Input}
          label='Descripción'
          placeholder='Descripción'
          disabled={disabledBtns}
          onChange={(e, {value}) => handleChange('principalPartDescription', value)}
        />
        {this.renderOperationTypeDropdown()}
      </Form.Group>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'permissions': state.session.permissions,
    'loading': state.warrantiesAdminCategories.loading,
    'part': state.warrantiesAdminCategories.part,
  };
};

const {getWarrantyAdminPart, clearSearchPartWarrantyAdmin} = Actions;

export default connect(mapStateToProps, {
  getWarrantyAdminPart,
  clearSearchPartWarrantyAdmin,
})(PrincipalPart);

